







import React, { useState,useEffect } from "react";
import {
  TextField,
  Button,
  Checkbox,
  FormControlLabel,
  Typography,
  Box,
  MenuItem,
  IconButton,
} from "@mui/material";
import ArrowBackIosNewIcon from "@mui/icons-material/ArrowBackIosNew";
import CloseIcon from "@mui/icons-material/Close";
import { useNavigate } from "react-router-dom";
import CustomDialog from "../../CustomDialog";
import { LocalizationProvider, DateTimePicker } from '@mui/x-date-pickers';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import {apiRequest} from '../../fetchSetup'
import axios from 'axios';




const BookAppointment = () => {
  const navigate = useNavigate();
  const [dialogOpen, setDialogOpen] = useState(false);
  const [dialogMessage, setDialogMessage] = useState("");
  const [formData, setFormData] = useState({
    fullName: "",
    email: "",
    phone: "",
    age: "",
    gender: "",
    service: "",
    priority: "",
    time: "",
    paymentMethod: "",
    prescriptions: [],
    terms: false,
  });
  const [errors, setErrors] = useState({});
  const bookAppointmentApi = process.env.REACT_APP_BOOK_APPOINTMENT_API;
  const prescriptionApi = process.env.REACT_APP_PRESCRIPTION_STORE_API;
  const getservicesApi = process.env.REACT_APP_GET_SERVICES;


  const paymentprocessApi = process.env.REACT_APP_PROCESS_PAYEMENT;
  const razorpaycreationApi = process.env.REACT_APP_CREATE_RAZORPAY_ORDER;
  const razorpaykeyApi = process.env.REACT_APP_RAZORPAY_KEY;

  const fieldStyle = {
    width: "48%",
    marginBottom: "16px",
  };



  const paymentMethods = [
    { label: "Pay online", value: "online" },
    { label: "Pay at Clinic", value: "offline" },
  ];

  const services = [
    "Elderly and Childcare",
    "Nursing & Physiotherapy Services",
    "Medicine & Diagnostic Delivery",
    "Emergency Care Support",
    "Doctor Visit, Pickup & Drop",
    "Social Wellness Activities",
  ];

  const gender = [
    { label: "Male", value: "male" },
    { label: "Female", value: "female" },
  ];
  const source = [
    { label: "WhatsApp", value: "whatapp" },
    { label: "PhoneCall", value: "phonecall" },
    { label: "In-Person", value: "inperson" },
  ];

  const priority = [
    { label: "Low", value: "Low" },
    { label: "Normal", value: "Normal" },
    { label: "High", value: "High" },
    { label: "Emergency", value: "Emergency" },
  ];

  const [serviceList, setServiceList] = useState([]); 

  useEffect(() => {
    const fetchServices = async () => {
      try {
        const res = await axios.get(getservicesApi);
        const data = await res.data;
        // Ensure the data is an array
        if (Array.isArray(data)) {
          setServiceList(data);
        } else if (data.services && Array.isArray(data.services)) {
          // if backend wraps it in an object
          setServiceList(data.services);
        } else {
          console.warn("Unexpected service response:", data);
          setServiceList([]);
        }
      } catch (err) {
        console.error("Failed to fetch services:", err);
        setServiceList([]);
      }
    };
    fetchServices();
  }, []);
  


  // Load Razorpay SDK
  const loadRazorpayScript = () => {
    return new Promise((resolve) => {
      const script = document.createElement("script");
      // script.src = "https://checkout.razorpay.com/v1/checkout.js";
      script.src = process.env.REACT_APP_RAZORPAY_SCRIPT;
      script.onload = () => resolve(true);
      script.onerror = () => resolve(false);
      document.body.appendChild(script);
    });
  };

  // Helper function to create booking after payment
  const createBooking = async (transactionId) => {
    try {
    const paymentData = {
      payment_id: transactionId,
      amount: formData.servicePrice,
      method: formData.paymentMethod,
      status: "success",
      transaction_history: [
        { timestamp: new Date().toISOString(), method: formData.paymentMethod },
      ],
    };

    const bookingPayload = {
      name: formData.fullName,
      email: formData.email,
      phone: formData.phone,
      age: formData.age,
      gender: formData.gender,
      priority: formData.priority,
      service_type: formData.service,
      date: formData.time,
      notes: "Uploaded via Web admin form",
      source: formData.source,
      payment: paymentData,
    };

    const res = await axios.post(bookAppointmentApi, bookingPayload,{
      headers: { "Content-Type": "application/json" },
    });

    const bookingData = await res.data;

    if (!res.data) {
      setDialogMessage(bookingData.error || "Failed to book appointment");
      setDialogOpen(true);
      return;
    }

    const bookingId = bookingData.booking_id;

    // Upload prescriptions
    if (formData.prescriptions.length > 0) {
      for (const file of formData.prescriptions) {
        const formDataObj = new FormData();
        formDataObj.append("file", file);

        const uploadRes = await axios.post(`${prescriptionApi}/${bookingId}`, formDataObj
        );

        const uploadData = await uploadRes.data;

        if (uploadRes.data) {
          console.log("📄 Prescription uploaded:", uploadData.file_path);
        } else {
          console.error("❌ Upload failed:", uploadData.error);
        }
      }
    }

    setDialogMessage(
      `Appointment booked successfully!\n\nName: ${formData.fullName}\nTime: ${formData.time}`
    );
    setDialogOpen(true);

    // Reset form
    setFormData({
      fullName: "",
      email: "",
      phone: "",
      age: "",
      gender: "",
      priority: "",
      service: "",
      time: "",
      paymentMethod: "",
      source:"",
      prescriptions: [],
      terms: false,
    });
     } catch (err) {
        console.error("Booking error:", err);
        setDialogMessage("Error", "Something went wrong while booking.");
        setDialogOpen(true);
      }
  };



  const handleSubmit = async (e) => {
    e.preventDefault();
  
    // 🔎 Basic validation first
    if (
      !formData.fullName ||
      !formData.email ||
      !formData.phone ||
      !formData.age ||
      !formData.gender ||
      !formData.priority ||
      !formData.service ||
      !formData.time ||
      !formData.paymentMethod ||
      !formData.terms ||
      !formData.source
    ) {
      setDialogMessage("⚠️ Please fill all required fields and accept terms.");
      setDialogOpen(true);
      return;
    }
  
    // ✅ Only proceed with payment AFTER validation passes
    await handlePayment();
  };
  
  const handlePayment = async () => {
    if (formData.paymentMethod === "offline") {
      // Directly create booking without Razorpay
      await createBooking("offline_txn_" + Date.now());
      return;
    }
  
    // ✅ Proceed only if online payment chosen
    if (formData.paymentMethod === "online") {
      const res = await loadRazorpayScript();
      if (!res) {
        setDialogMessage("Razorpay SDK failed to load");
        setDialogOpen(true);
        return;
      }
     const bookingPayload = {
      name: formData.fullName,
      email: formData.email,
      phone: formData.phone,
      age: formData.age,
      gender: formData.gender,
      priority: formData.priority,
      service_type: formData.service,
      date: formData.time,
      notes: "Uploaded via Web admin form",
      source: formData.source,
      community:formData.address.community_name,
    };
      const amountToPay = formData.servicePrice || 1; 
      // Create Razorpay order on backend
      const orderRes = await axios.post(razorpaycreationApi,
        {
            amount: amountToPay,
            currency: "INR",
            payment_method: "online",          
            booking_payload: bookingPayload,
          },
        {
          headers: { "Content-Type": "application/json" }
        }
      )
  
      const orderData = await orderRes.data;
      if (!orderRes.data) {
        setDialogMessage(orderData.error || "Failed to create payment order");
        setDialogOpen(true);
        return;
      }
      sessionStorage.setItem('currentDiagnosticOrderId',orderData.booking_id)
      sessionStorage.setItem('bookingPayload',JSON.stringify(bookingPayload))
  
      const options = {
        // key: "rzp_test_RLPNXraO5Rywls",
        key:razorpaykeyApi,
        amount: orderData.amount,
        currency: orderData.currency,
        name: "Ayuja Services",
        order_id: orderData.order_id,
        prefill: {
          name: formData.fullName,
          email: formData.email,
          contact: formData.phone,
        },
        theme: { color: "#008080" },
        handler: async function (response) {
          // Verify on backend
          const verifyRes = await axios.post(paymentprocessApi,{

                razorpay_payment_id: response.razorpay_payment_id,
                razorpay_order_id: response.razorpay_order_id,
                razorpay_signature: response.razorpay_signature,
                method: "online",
                amount: orderData.amount,
                name: formData.fullName,
                email: formData.email,
                phone: formData.phone
            },
            {

              headers: { "Content-Type": "application/json" }
            }
          );
  
          const paymentResult = await verifyRes.data;
          if (paymentResult.status !== "success") {
            setDialogMessage("Payment failed. Try again.");
            setDialogOpen(true);
            return;
          }
  
          await createBooking(paymentResult.transaction_id);
        },
      };
  
      const rzp = new window.Razorpay(options);
      rzp.open();
    }
  };
  
  const handleChange = (e) => {
    const { name, value, type, checked, files } = e.target;
    setFormData({
      ...formData,
      [name]:
        type === "checkbox"
          ? checked
          : type === "file"
          ? Array.from(files)
          : value,
    });
  };
  const textFieldSx = ({
    textColor = "black",
    labelColor = "black",
    borderColor = "#fff",
    borderRadius = 4,
    backgroundColor = "#fff",
  } = {}) => ({
    backgroundColor: backgroundColor,
    borderRadius: borderRadius,
    "& .MuiInputBase-input": {
      color: textColor,
    },
    "& .MuiInputLabel-root": {
      color: labelColor,
    },
    "& .MuiOutlinedInput-root": {
      "& fieldset": {
        borderColor: borderColor,
        borderRadius: borderRadius,
      },
      "&:hover fieldset": {
        borderColor: borderColor,
        borderRadius: borderRadius,
      },
      "&.Mui-focused fieldset": {
        borderColor: borderColor,
        borderRadius: borderRadius,
      },
    },
  });
  return (
    <>
      <Box sx={{ pb: 10 }}>
        <Box
          component="form"
          onSubmit={handleSubmit}
          sx={{
            flexGrow: 1,
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            px: 2,
            mt: 4,
          }}
        >
          <Box
            sx={{
              backgroundColor:"#006D77",
              color: "#fff",
              p: 3,
              borderRadius: "30px",
              boxShadow: 5,
              maxWidth: "700px",
              width: "100%",
            }}
          >
            <IconButton
              onClick={() => navigate(-1)}
              sx={{ width: 80, height: 80 }}
            >
              <ArrowBackIosNewIcon sx={{ fontSize: 30, color: "#fff" }} />
            </IconButton>
            <Typography
              variant="h5"
              gutterBottom
              sx={{ fontWeight: "bold", mb: 2, textAlign: "center" }}
            >
              Book Appointment
            </Typography>

            <Box sx={{ display: "flex", flexWrap: "wrap", gap: "2%" }}>
              {/* Form Fields */}
              <TextField
              name="fullName"
              label="Full Name"
              variant="outlined"
              value={formData.fullName}
              onChange={(e) => {
                const { value } = e.target;
                // ✅ Allow only alphabets and spaces
                if (/^[A-Za-z ]*$/.test(value)) {
                  handleChange(e);
                }
              }}
              sx={{ ...fieldStyle, ...textFieldSx({ textColor: "black", borderColor: "white" }) }}
            />
        
          <TextField
            name="email"
            label="Email"
            variant="outlined"
            required
            type="email" 
            value={formData.email}
            onChange={(e) => {
              const { value } = e.target;
              handleChange(e);
            
              // ✅ Live email validation
              if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(value)) {
                setErrors((prev) => ({ ...prev, email: "Invalid email format" }));
              } else {
                setErrors((prev) => ({ ...prev, email: "" }));
              }
            }}
            sx={{ ...fieldStyle, ...textFieldSx({ textColor: "black", borderColor: "white" }) }}
          />

          <TextField
            name="phone"
            label="Phone"
            variant="outlined"
            required
            value={formData.phone}
            onChange={(e) => {
              const { value } = e.target;

              // Allow only digits and max 10
              if (/^\d{0,10}$/.test(value)) {
                handleChange(e);

                // ✅ Live validation
                if (value.length < 10) {
                  setErrors((prev) => ({ ...prev, phone: "Phone number must be 10 digits" }));
                } else {
                  setErrors((prev) => ({ ...prev, phone: "" }));
                }
              }
            }}
            inputProps={{ inputMode: "numeric", pattern: "[0-9]*", maxLength: 10 }}
            sx={{ ...fieldStyle, ...textFieldSx({ textColor: "black", borderColor: "white" }) }}
          />

          <TextField
            name="age"
            label="Age"
            variant="outlined"
            required
            type="number"
            value={formData.age}
            onChange={(e) => {
              const { value } = e.target;

              // Allow only up to 2 digits
              if (/^\d{0,2}$/.test(value)) {
                handleChange(e);

                // ✅ Live validation
                if (value === "" || parseInt(value) < 1 || parseInt(value) > 99) {
                  setErrors((prev) => ({ ...prev, age: "Age must be between 1 and 99" }));
                } else {
                  setErrors((prev) => ({ ...prev, age: "" }));
                }
              }
            }}
            inputProps={{ maxLength: 2, inputMode: "numeric", pattern: "[0-9]*" }}
            sx={{ ...fieldStyle, ...textFieldSx({ textColor: "black", borderColor: "white" }) }}
          />

              
              <TextField
                select
                label="Gender"
                name="gender"
                value={formData.gender}
                onChange={handleChange}
                variant="outlined"
                required
                sx={{ ...fieldStyle, ...textFieldSx({ textColor: "black", borderColor: "white" }) }}
              >
                {gender.map((g, i) => (
                  <MenuItem key={i} value={g.value}>
                    {g.label}
                  </MenuItem>
                ))}
              </TextField>

              <TextField
                select
                label="Source"
                name="source"
                value={formData.source}
                onChange={handleChange}
                variant="outlined"
                required
                sx={{ ...fieldStyle, ...textFieldSx({ textColor: "black", borderColor: "white" }) }}
              >
                {source.map((g, i) => (
                  <MenuItem key={i} value={g.value}>
                    {g.label}
                  </MenuItem>
                ))}
              </TextField>


              
              <TextField
                select
                label="Priority"
                name="priority"
                value={formData.priority}
                onChange={handleChange}
                variant="outlined"
                required
                sx={{ ...fieldStyle, ...textFieldSx({ textColor: "black", borderColor: "white" }) }}
              >
                {priority.map((p, i) => (
                  <MenuItem key={i} value={p.value}>
                    {p.label}
                  </MenuItem>
                ))}
              </TextField>

            <TextField
              select
              name="service"
              label="Select Service"
              value={formData.service}
              onChange={(e) => {
                const selectedService = serviceList.find(
                  (s) => s.name === e.target.value
                );
                setFormData({
                  ...formData,
                  service: selectedService?.name || "",
                  servicePrice: selectedService?.price || 0,
                });
              }}
              variant="outlined"
              required
              sx={{ ...fieldStyle, ...textFieldSx({ textColor: "black", borderColor: "white" }) }}
            >
              {/* Placeholder option */}
              <MenuItem value="" disabled>
                Please select service
              </MenuItem>

              {serviceList.map((s, i) => (
                <MenuItem key={i} value={s.name}>
                  {s.name}
                </MenuItem>
              ))}
            </TextField>

              <TextField
                name="time"
                type="datetime-local"
                label="Appointment Time *"
                value={formData.time}
                onChange={handleChange}
                variant="outlined"
                required
                sx={{ ...fieldStyle, ...textFieldSx({ textColor: "black", borderColor: "white" }) }}
                InputLabelProps={{ shrink: true }}
                inputProps={{ min: new Date().toISOString().slice(0, 16) }}
              />

{/* 
<LocalizationProvider dateAdapter={AdapterDateFns}>
  <DateTimePicker
    label="Appointment Time *"
    value={formData.time ? new Date(formData.time) : null}
    onChange={(newValue) => {
      if (newValue) {
        // convert to string without 'Z'
        const localISOString = newValue.toISOString().slice(0, 16);
        handleChange({ target: { name: "time", value: localISOString } });
      }
    }}
    renderInput={(params) => (
      <TextField
        {...params}
        required
        sx={{ ...fieldStyle, ...textFieldSx({ textColor: "black", borderColor: "white" }) }}
      />
    )}
    minDateTime={new Date()}
  />
</LocalizationProvider> */}






              <TextField
                select
                label="Payment Method"
                name="paymentMethod"
                value={formData.paymentMethod}
                onChange={handleChange}
                variant="outlined"
                required
                sx={{ ...fieldStyle, ...textFieldSx({ textColor: "black", borderColor: "white" }) }}
              >
                {paymentMethods.map((method, i) => (
                  <MenuItem key={i} value={method.value}>
                    {method.label}
                  </MenuItem>
                ))}
              </TextField>

              

              <Box
                sx={{ width: "100%", backgroundColor: "#fff", borderRadius: 4, p: 1 }}
              >
                <input
                  type="file"
                  name="prescriptions"
                  multiple
                  accept="image/*,.pdf"
                  onChange={handleChange}
                  style={{ display: "block", width: "100%", padding: "10px", borderRadius: "4px" }}
                />
                {formData.prescriptions.length > 0 && (
                  <Box sx={{ mt: 1 }}>
                    <Typography variant="body2" color="#000">
                      Selected Files:
                    </Typography>
                    <ul style={{ color: "black", paddingLeft: "20px" }}>
                      {formData.prescriptions.map((file, index) => (
                        <li
                          key={index}
                          style={{
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "space-between",
                          }}
                        >
                          <span>{file.name}</span>
                          <IconButton
                            size="small"
                            onClick={() => {
                              setFormData((prev) => ({
                                ...prev,
                                prescriptions: prev.prescriptions.filter((_, i) => i !== index),
                              }));
                            }}
                          >
                            <CloseIcon fontSize="small" />
                          </IconButton>
                        </li>
                      ))}
                    </ul>
                  </Box>
                )}
              </Box>

              <FormControlLabel
                control={
                  <Checkbox
                    name="terms"
                    checked={formData.terms}
                    onChange={handleChange}
                    required
                    sx={{ color: "white" }}
                  />
                }
                label={
                  <Typography variant="body2">
                    I accept all{" "}
                    <span style={{ color: "#4caf50" }}>terms and conditions</span>
                  </Typography>
                }
                sx={{ width: "100%" }}
              />
                          <Typography
              variant="caption"
              color="error"
              sx={{ mt: 0.5, display: "block" ,fontSize:20}}
            >
              {errors.phone && `${errors.phone}`}
              {errors.phone && errors.age ? " | " : ""}
            </Typography>
            </Box>

            <Box textAlign="center" mt={2}>
              <Button
                type="submit"
                variant="contained"
                sx={{
                  backgroundColor: "#66f2a7",
                  color: "#003333",
                  fontWeight: "bold",
                  borderRadius: "8px",
                  width: "50%",
                  py: 1.2,
                  "&:hover": { backgroundColor: "#55d792" },
                }}
              >
                Pay & Book Now
              </Button>
            </Box>
          </Box>
        </Box>
      </Box>
      <CustomDialog
  open={dialogOpen}
  message={dialogMessage}
  onClose={() => setDialogOpen(false)}
/>

    </>
  );
};

export default BookAppointment;
